<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        Localidades
        <v-btn
          class="mx-2"
          fab
          small
          dark
          color="indigo"
          title="Nova localidade"
          @click="createItem"
        >
          <v-icon small>mdi-plus</v-icon>
        </v-btn>
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
          clearable
        />
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="places"
        :search="search"
        :loading="loading"
        loading-text="Buscando localidades..."
        no-data-text="Nenhuma localidade cadastrada."
      >
        <template v-slot:item.active="{ item }">
          <v-chip small dark :color="item.active !== false ? 'green' : 'grey'">
            {{ item.active !== false ? "Ativa" : "Inativa" }}
          </v-chip>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-3" title="Editar" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon
            v-if="item.active !== false"
            small
            color="red"
            title="Desativar"
            @click="requestDelete(item)"
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>

    <place-form-dialog
      v-model="formDialog"
      :place="selectedPlace"
      @saved="handleSaved"
      @error="handleError"
    />
    <place-delete-dialog
      v-model="deleteDialog"
      :place="selectedPlace"
      @deleted="handleDeleted"
      @error="handleError"
    />

    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" top>
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.visible = false">
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import PlaceDeleteDialog from "../../components/admin/places/PlaceDeleteDialog.vue";
import PlaceFormDialog from "../../components/admin/places/PlaceFormDialog.vue";
import { getPlaces } from "../../services/places";

export default {
  name: "PlaceList",
  components: {
    PlaceDeleteDialog,
    PlaceFormDialog,
  },
  data() {
    return {
      search: "",
      loading: true,
      places: [],
      selectedPlace: null,
      formDialog: false,
      deleteDialog: false,
      unsubscribe: null,
      snackbar: {
        visible: false,
        text: "",
        color: "green",
      },
      headers: [
        { text: "Nome", value: "name" },
        { text: "Descrição", value: "description" },
        { text: "Status", value: "active" },
        { text: "Ações", value: "actions", sortable: false },
      ],
    };
  },
  mounted() {
    this.unsubscribe = getPlaces().onSnapshot(
      (snapshot) => {
        this.places = snapshot.docs.map((document) => ({
          id: document.id,
          ...document.data(),
        }));
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.handleError(error);
      }
    );
  },
  beforeDestroy() {
    if (this.unsubscribe) this.unsubscribe();
  },
  methods: {
    createItem() {
      this.selectedPlace = null;
      this.formDialog = true;
    },
    editItem(place) {
      this.selectedPlace = { ...place };
      this.formDialog = true;
    },
    requestDelete(place) {
      this.selectedPlace = { ...place };
      this.deleteDialog = true;
    },
    handleSaved({ message }) {
      this.showSnackbar(message, "green");
    },
    handleDeleted() {
      this.showSnackbar("Localidade desativada com sucesso.", "green");
    },
    handleError(error) {
      console.error(error);
      this.showSnackbar("Não foi possível concluir a operação.", "red");
    },
    showSnackbar(text, color) {
      this.snackbar = {
        visible: true,
        text,
        color,
      };
    },
  },
};
</script>
